import styled from 'styled-components';

export const SignatureSuccessDesktop = styled.div`
	display: flex;
	height: 100vh;
	padding: 2rem 5rem;
	flex: 1;
	display: flex;
	justify-content: center;
	background-color: #F5F5F5;
`;

SignatureSuccessDesktop.Term = styled.div`
	max-width: 85vh;
	height: 636px;
	margin-right: 1rem;
`;

SignatureSuccessDesktop.TermContainer = styled.div`
	height: 100%;
	box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
	background-color: #FFF;
	color: black;
	padding: 1rem 3rem;
	min-width: 514px;
`;

SignatureSuccessDesktop.TermTextContainer = styled.div`
	max-width: 85vh;
	min-height: 420px;
`;

SignatureSuccessDesktop.TermTitle = styled.div`
	text-transform: uppercase;
	font-weight: 500;
	font-size: 16px;
	margin: 1rem 0;
`;

SignatureSuccessDesktop.TermText = styled.div`
	margin-top: 1rem;
	font-weight: 400;
	font-size: 16px;
`;

SignatureSuccessDesktop.TermFooter = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 22px;
`;

SignatureSuccessDesktop.ContainerSignature = styled.div`
	display: row;
	justify-content: center;
`;

SignatureSuccessDesktop.SignatureBox = styled.img`
	width: 180px;
	margin: 0 auto;
	height: 80px;
`;

SignatureSuccessDesktop.Signature = styled.div`
	width: 70vh;
	height: 392px;
	color: blue;
	background-color: purple;
	margin-left: 1rem;
`;

SignatureSuccessDesktop.SignatureContainer = styled.div`
	height: 100%;
	box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
	background-color: #FFF;
	color: black;
	padding: 3rem;
`;

SignatureSuccessDesktop.SignatureCenter = styled.div`
	display: flex;
	justify-content: center;
`;

SignatureSuccessDesktop.SignatureTitle = styled.h1`
	font-weight: 500;
	font-size: 24px;
	text-align: center;
	color: #26282A;
`;

SignatureSuccessDesktop.SignatureText = styled.p`
	font-weight: 400;
	font-size: 16px;
	text-align: center;
	color: #4E5255;
	margin-top: 0;
`;

SignatureSuccessDesktop.UserContainer = styled.div`

`;

SignatureSuccessDesktop.UserName = styled.p`
	word-break: break-all;
	font-weight: 500;
	font-size: 16px;
	color: #26282A;
	line-height: 20px;
`;

SignatureSuccessDesktop.Cpf = styled.p`
	font-weight: 400;
	font-size: 14px;
	color: #4E5255;
	line-height: 20px;
`;


SignatureSuccessDesktop.ImageSuccess = styled.img`
	width: 64px;
	height: 64px;
`;

SignatureSuccessDesktop.AnchorProps = styled.a`
	width: 100%;
	margin: 16px 0;
	margin-top: 2rem;
`;

SignatureSuccessDesktop.Button = styled.button`
	color: #26282A;
	border: 1px solid #D9E1E8;
	border-radius: 8px;
	height: 50px;
	display: flex;
	width: 100%;
	justify-content: center;
`;

SignatureSuccessDesktop.ButtonText = styled.p`
	font-size: 16px;
`;
